import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.css']
})
export class FaqsComponent implements OnInit {

  glossarySearch:any;
  termNotFounderror:Boolean = false;
  errorMessage:any;

  termFound :Boolean = false;
  termOrDefinitioResult:any;
  
  constructor() { 
  }

  ngOnInit() {
  }

  activate(){
    this.termNotFounderror = false;
    this.termFound  = false;
    this.glossarySearch = '';
    this.termOrDefinitioResult = '';
  }

  search(){

    if(this.glossarySearch === undefined) {
      this.termNotFounderror = true;
      this.errorMessage = "Please indicated a valid Term or Definition.";
    }  

    if(this.glossarySearch.trim().toLocaleLowerCase() === 'Good cause'.toLocaleLowerCase()) {
      this.termNotFounderror = false;
      this.termFound  = true;
      this.termOrDefinitioResult ="Good cause is a legal term denoting adequate or substantial grounds or reason to take a certain action, or to fail to take an action prescribed by law. What constitutes a good cause is usually determined on a case by case basis and is thus relative";
    } else {
      this.termNotFounderror = true;
      this.errorMessage = "Term or Definition not found.";
    }  
  }
 
}



// WEBPACK FOOTER //
// ./src/app/faqs/faqs.component.ts